import type {
  CrmsAttachment,
  CrmsSearchQuery,
  GeoDBSearchQuery,
  GeomateSearchQuery,
  ImportDBResultViewMode,
  KsuWell,
  OverallSearchQuery,
} from '@core/core/types'
import type { Nullable, ProjectId } from 'common/types'

export type NewImportResultsProps = {
  projectId: ProjectId
  mode: ImportDBResultViewMode
  globalSearch: string
  activeQuery: OverallSearchQuery
  addGeoDFiles: (files: KsuWell[]) => void
  addCrmsFiles: (files: CrmsAttachment[]) => void
}

export type SearchModeComboItem = { mode: ImportDBResultViewMode; label: string }

export const searchModeComboItems: SearchModeComboItem[] = [
  { mode: 'alldb', label: 'Все базы данных' },
  { mode: 'geodb', label: 'ГеоБД' },
  { mode: 'crms', label: 'ЦРМС' },
  { mode: 'geomate', label: 'ГеоМейт' },
]

export type CrmsSearchFiltersProps = {
  query: CrmsSearchQuery | undefined
  territoryChanged: (value: Nullable<string>) => void
  projectIdChanged: (value: Nullable<string>) => void
  executorChanged: (value: Nullable<string>) => void
  startYearChanged: (value: number | undefined) => void
  endYearChanged: (value: number | undefined) => void
}

export type GeoDbSearchFiltersProps = {
  query: GeoDBSearchQuery | undefined
  companyChanged: (value: string | undefined) => void
  fieldChanged: (value: string | undefined) => void
  licenseAreaChanged: (value: string | undefined) => void
}

export type GeomateSearchFiltersProps = {
  query?: GeomateSearchQuery | undefined
}
